/**
 * Générateur — Il gère le déclenchement d'un script en réponse à un
 * événement.
 * Attendu ID : 247 | Niveau : 3ème | Domaine : Algorithmique (d21, O2 niv. 2)
 *
 * ⚠️ BANQUE 3e (doc muet — option (a) du TODO §5). Plan auto-validé
 * 2026-07-18 : « chapeau » (quelle situation → quel bloc chapeau, QCM),
 * « associer » (relier événements ↔ blocs chapeaux).
 */

import { randomChoice, shuffle, makeQcm, makeRelier } from '../../../utils';

const ATTENDU_ID = 247;
const L_CHAPEAU = 'Le bon bloc événement';
const L_ASSOCIER = 'Associer événements et blocs';
const opts = (label) => ({ niveau: '3eme', matiere: 'maths', attendu: ATTENDU_ID, label });

// [situation, bloc chapeau]
const EVENEMENTS = [
    ['le joueur lance le jeu avec le drapeau vert', 'quand le drapeau vert est cliqué'],
    ['le joueur appuie sur la touche espace', 'quand la touche espace est pressée'],
    ['le joueur clique directement sur le lutin', 'quand ce lutin est cliqué'],
    ['un autre script diffuse le message « Perdu »', 'quand je reçois « Perdu »'],
    ['le joueur appuie sur la flèche droite', 'quand la touche flèche droite est pressée'],
    ['deux lutins entrent en contact', 'quand ce lutin touche un autre lutin'],
    ['le niveau sonore du micro dépasse un seuil', 'quand le volume sonore > 10'],
    ['le décor passe à l\'arrière-plan « Niveau 2 »', 'quand l\'arrière-plan bascule sur « Niveau 2 »'],
];

// ═════════ « chapeau » — QCM ═════════

const genChapeauQcm = () => {
    const tirage = shuffle(EVENEMENTS).slice(0, 4);
    const [situation, correct] = tirage[0];
    const habillage = randomChoice(['saut du personnage', 'tir du vaisseau', 'départ de la course', 'changement de décor']);
    const payload = makeQcm(shuffle(tirage.map(e => e[1])), correct,
        `<p>Dans un jeu, le script « ${habillage} » doit démarrer quand ${situation}.</p>`
        // « (bloc de déclenchement) » traduit « bloc CHAPEAU », le terme même
        // du programme que la carte fait apprendre.
        + '<p><b>Quel bloc CHAPEAU faut-il placer en tête du script ?</b></p>',
        opts(L_CHAPEAU));
    payload._meta.params = { situation, correct, habillage };
    return payload;
};

// ═════════ « associer » — relier ═════════

const genAssocierRelier = () => {
    const tirage = shuffle(EVENEMENTS).slice(0, 4);
    const payload = makeRelier(tirage.map(([s, b]) => ({ source: s, target: b })),
        '<p>Chaque script d\'un jeu démarre en réponse à un ÉVÉNEMENT.</p>'
        + '<p><b>Associe chaque situation au bloc chapeau qui la détecte.</b></p>',
        opts(L_ASSOCIER));
    payload._meta.params = { tirage };
    return payload;
};

const GENERATORS = {
    chapeau_qcm_unique: genChapeauQcm,
    associer_relier: genAssocierRelier,
};
const FORMAT_LABELS = { qcm_unique: 'QCM', relier: 'Relier' };
const buildFormats = (prefix) =>
    Object.keys(GENERATORS).filter(k => k.startsWith(`${prefix}_`))
        .map(k => ({ key: k, label: FORMAT_LABELS[k.slice(prefix.length + 1)] || k }));
export const CATEGORIES = [
    { id: 'chapeau', label: L_CHAPEAU, formatsList: buildFormats('chapeau') },
    { id: 'associer', label: L_ASSOCIER, formatsList: buildFormats('associer') },
];
export const generate = (typeExercice) => {
    let key;
    if (typeExercice && GENERATORS[typeExercice]) key = typeExercice;
    else if (typeExercice) {
        const matching = Object.keys(GENERATORS).filter(k => k.startsWith(typeExercice) || k.includes(typeExercice));
        key = matching.length ? randomChoice(matching) : randomChoice(Object.keys(GENERATORS));
    } else key = randomChoice(Object.keys(GENERATORS));
    const payload = GENERATORS[key]();
    payload._meta.generatorKey = key;
    return payload;
};
